import { useMemo } from 'react';

import { getWeek, getWeeksInYear, getYear } from '../../../utils/date';
import { Cell } from '../Cell';
import { Controls } from '../Controls';

type Props = {
  selectedWeek?: number;
  displayYear: number;
  onPreviousYear: () => void;
  onNextYear: () => void;
  onSelectWeek: (_week: number) => void;
  onHeaderClick: () => void;
  maxDate?: number;
  minDate?: number;
};

export const WeekView = ({
  displayYear,
  selectedWeek,
  onSelectWeek,
  onPreviousYear,
  onNextYear,
  onHeaderClick,
  maxDate,
  minDate,
}: Props) => {
  const { nbWeeks } = useMemo(() => {
    const nbWeeks = getWeeksInYear(displayYear);

    return { nbWeeks };
  }, [displayYear]);

  const { maxYear, minYear, maxWeek, minWeek } = useMemo(() => {
    const maxYear = maxDate ? getYear(maxDate) : undefined;
    const minYear = minDate ? getYear(minDate) : undefined;
    const maxWeek = maxDate ? getWeek(maxDate) : undefined;
    const minWeek = minDate ? getWeek(minDate) : undefined;
    return { maxYear, minYear, maxWeek, minWeek };
  }, [maxDate, minDate]);

  return (
    <div className="inline-block">
      <Controls
        onHeaderClick={onHeaderClick}
        onPrevious={onPreviousYear}
        onNext={onNextYear}
        label={`${displayYear}`}
        isNextDisabled={!!maxYear && displayYear >= maxYear}
        isPreviousDisabled={!!minYear && displayYear <= minYear}
      />

      <div>
        <div className="w-64 grid grid-cols-7 gap-1">
          {Array.from({ length: nbWeeks }).map((_, index) => (
            <Cell
              key={index}
              onClick={() => onSelectWeek(index + 1)}
              isSelected={selectedWeek === index + 1}
              isDisabled={
                (!!maxYear &&
                  !!maxWeek &&
                  (displayYear > maxYear || (displayYear === maxYear && index + 1 > maxWeek))) ||
                (!!minYear && !!minWeek && (displayYear < minYear || (displayYear === minYear && index + 1 < minWeek)))
              }
            >
              S{index + 1}
            </Cell>
          ))}
        </div>
      </div>
    </div>
  );
};
